
















import { Component, Prop, Vue } from "vue-property-decorator";
import { KebidananAlert } from "@/types/LembarObservasiAsuhanKebidanan";

@Component
export default class AlertRisiko extends Vue {
  @Prop({ default: () => [] }) alerts!: KebidananAlert[];

  typeOf(level: string): string {
    if (level === "critical") return "error";
    if (level === "warning") return "warning";
    return "info";
  }

  formatCode(code: string): string {
    return code.toUpperCase().replace(/_/g, " ");
  }
}
